import AddressList from './AddressList';

export default AddressList;



// WEBPACK FOOTER //
// ./src/ondemand/components/AddressList/index.js